import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import {
  FleetVehiclePicture,
  FleetVehiclePictureEditFormValues,
  FleetVehiclePictureRow,
} from "./types";

/*---------------------------------------------------------------------------------------
    VEHICLE CONTRACT
  -----------------------------------------------------------------------------------------*/

export const transformFleetVehiclePictureRow = (
  res: any
): FleetVehiclePictureRow => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    upload: res.upload,
    url: res.url,
    displayOrder: res.displayOrder ?? null,
  };
};

export const transformFleetVehiclePictureOnCreate = (
  vehicleId: string,
  uploadId: string,
  name: string | null,
  description: string | null
): any => ({
  vehicleId: vehicleId,
  uploadId: uploadId,
  name: name,
  description: description,
});

export const transformFleetVehiclePicture = (res: any): FleetVehiclePicture => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    files: res.upload,
    url: res.url,
    displayOrder: res.displayOrder ?? null,
  };
};

export const transformFleetVehiclePictureToFormValues = (
  picture: FleetVehiclePicture
): FleetVehiclePictureEditFormValues => {
  const fakeFile: Partial<FileExtended> = {
    id: picture.id,
    name: picture.name || "",
    url: picture.url,
  };

  return {
    id: picture.id,
    name: picture.name,
    description: picture.description,
    files: [fakeFile as FileExtended],
  };
};
